import { isDenebEnabled } from '@/const/flags'

import { useLanguage as useAltairLanguage } from './useLanguage.altair'
import { useLanguage as useDenebLanguage } from './useLanguage.deneb'

export const useLanguage = isDenebEnabled ? useDenebLanguage : useAltairLanguage
